/* tslint:disable */

declare var Object: any;
export interface EmployeeRequestInterface {
  "id"?: number;
}

export class EmployeeRequest implements EmployeeRequestInterface {
  "id": number;
  constructor(data?: EmployeeRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `EmployeeRequest`.
   */
  public static getModelName() {
    return "EmployeeRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of EmployeeRequest for dynamic purposes.
  **/
  public static factory(data: EmployeeRequestInterface): EmployeeRequest{
    return new EmployeeRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'EmployeeRequest',
      plural: 'EmployeeRequests',
      path: 'EmployeeRequests',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/EmployeeRequest.ts